<template>
    <tbody :class="{'info-visible': infoVisible}">
        <tr :aria-expanded="infoVisible ? 'true' : 'false'" class="prospectus-row" @keyup.enter="toggleInfoVisibility" @click="toggleInfoVisibility" tabindex="0">
            <td>{{prospectus.companies.map(x => x.companyName).join(', ')}}</td>
            <td>{{FormatDate(prospectus.approvalDate)}}</td>
            <td>{{translatedInfo(prospectus)}}</td>

            <td v-if="prospectus.prospectusType!==4">{{prospectus.nationalIdentifier}}</td>
            <td v-if="prospectus.prospectusType===4">{{FormatDate(prospectus.notificationDate)}}</td>

            <td v-if="prospectusTypesWithListing.includes(prospectus.prospectusType)">{{YesNo(prospectus.listed)}}</td>
            <td v-else-if="prospectusTypesWithListing.includes(lastSearchParams.ProspectusType) || !lastSearchParams.ProspectusType"></td>
        </tr>
        <prospectus-item-info :prospectus="prospectus" v-if="infoVisible" />
    </tbody>
</template>

<script>
    import { mapState, mapGetters } from "vuex";
    import ProspectusItemInfo from './ProspectusItemInfo.vue';

    export default {
        components: {
            ProspectusItemInfo
        },
        data() {
            return {
                infoVisible: false
            }
        },
        methods: {
            toggleInfoVisibility() {
                this.infoVisible = !this.infoVisible;
            },
            translatedInfo: function (prospectus) {
                var lang = this.conf.language == "sv" ? "SE" : this.conf.language.toUpperCase();
                var fieldName = (prospectus.prospectusType == 3 || prospectus.prospectusType == 4) ? "securityType": "additionalInfo";
                return eval("prospectus." + fieldName + lang) ;
            }
        },
        watch: {
            prospectus(newValue) {
                this.infoVisible = false;
            }
        },
        props: {
            prospectus: Object
        },
        computed: {
            ...mapGetters(["YesNo", "FormatDate"]),
            ...mapState(["conf", "prospectusTypesWithListing", "lastSearchParams"])
          
        }
    }
</script>

<style lang="scss" scoped>
</style>